import TextBox from '../components/Atoms/TextBox';
import React, { useState, Component } from 'react';
import { client } from '../client';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Slider from "react-slick";
import HeroSlider from '../components/Organisms/HeroSlider';
import WorksSection from '../components/Organisms/WorksSection'
import WorksDescription from '../components/Organisms/WorkDescription';
import TopBarAlt from '../components/Organisms/TopBarAlt'






class ItemDetail extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      itemData: [],
      category: '',
      description: '',
      exhibitionPlace: '',
      featured: false,
      imagesCarousel: [],
      installationImages: [],
      links: '',
      practicalInfo: '',
      thumbnail: '',
      title: '',
      titleEnglish: '',
      videoLinks: [],
      year: ''
    }  

  }

  //this is where we receive API calls inside components
  componentDidMount() {

    this.fetchWorkItems (this.props.match.params.id)
    // // getting id from url via react router
    // client.getEntry(`${this.props.match.params.id}`)
    // // client.getEntry("3XreWvZ2VYlUGAKGl9TGWJ")
    //   .then((response) => {
    //     this.setState({
    //       itemData : response,
    //       category: response.fields.category,
    //       description: response.fields.description,
    //       exhibitionPlace: response.fields.exhibitionPlace,
    //       featured: response.fields.featured,
    //       imagesCarousel: response.fields.imagesCarousel,
    //       installationImages: response.fields.installationImages,
    //       links: response.fields.links,
    //       practicalInfo: response.fields.practicalInfo,
    //       thumbnail: response.fields.thumbnail.fields.file.url,
    //       title: response.fields.title,
    //       titleEnglish: response.fields.titleEnglish,
    //       videoLinks: response.fields.videoLinks,
    //       year: response.fields.year
    //     })
    //     // console.log(this.state.itemData)
    // })
    // .catch(console.error)
  }
  
 
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id != this.props.match.params.id)
        this.fetchWorkItems(this.props.match.params.id);
  }

  fetchWorkItems (id) {
// getting id from url via react router
client.getEntry(id)
// client.getEntry("3XreWvZ2VYlUGAKGl9TGWJ")
  .then((response) => {
    this.setState({
      itemData : response,
      category: response.fields.category,
      description: response.fields.description,
      exhibitionPlace: response.fields.exhibitionPlace,
      featured: response.fields.featured,
      imagesCarousel: response.fields.imagesCarousel,
      installationImages: response.fields.installationImages,
      links: response.fields.links,
      practicalInfo: response.fields.practicalInfo,
      thumbnail: response.fields.thumbnail.fields.file.url,
      title: response.fields.title,
      titleEnglish: response.fields.titleEnglish,
      videoLinks: response.fields.videoLinks,
      year: response.fields.year
    })
    // console.log(this.state.itemData)
})
.catch(console.error)

  }







  render() {

    const {itemData, title, imagesCarousel, videoLinks} = this.state;
    
  
    return (<div>
        <TopBarAlt open={false}/>
        <HeroSlider images={imagesCarousel} videoLinks={videoLinks}/>

        
        <WorksDescription data={itemData}/>

        <WorksSection />
      </div>
    );
  }
}



export default ItemDetail;



